module.exports = __webpack_public_path__ + "static/media/currentCircle.92f99f9f.svg";